import { ArrayHelpers, Copy, DomHelpers, StringHelpers, SystemText } from 'e4shared';
import React from 'react';
import { ratingColour } from 'helpers/metrics';
import { withRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';

export const MetricRecommendations = ({ competencies, text, metrics }) => {
    const [showPercent, setShowPercent] = React.useState(true);
    const [idx, setIdx] = React.useState(0);
    const [validCompetencies, setValidCompetencies] = React.useState([]);

    const user = useSelector(state => state.user.user);

    const localColour = (x, i) => {
        x = i === 0 ? 5 : i === 1 ? 4 : 3;
        return ratingColour(x);
    };

    const loaded = React.useRef(null);

    React.useEffect(() => {
        competencies && setValidCompetencies(competencies.filter(c => ArrayHelpers.existsAndHasLength(c.improvements)));
    }, [competencies]);

    React.useEffect(() => {
        loaded.current && setTimeout(DomHelpers.matchWidth('fix-size', loaded.current), 250);
    }, [loaded.current]);

    React.useEffect(() => {
        DomHelpers.matchWidth('fix-size', loaded.current);
    }, [showPercent]);

    if (!ArrayHelpers.existsAndHasLength(validCompetencies) && !ArrayHelpers.existsAndHasLength(metrics)) {
        return <div>{SystemText('Dashboard/Widgets/Recommends/NoData')}</div>;
    }

    const summaryText =
        text || SystemText('Home/Widgets/Recommends/Text', validCompetencies[idx].users, validCompetencies[idx].competency);

    const improvementMetrics = metrics || validCompetencies[idx].improvements;

    return (
        <div ref={loaded}>
            <p>
                <Copy value={summaryText} />
            </p>
            <ul>
                {improvementMetrics.map((c, i) => {
                    const value = showPercent ? c.improvement : c.value;
                    const format = showPercent ? 'P' : c.format;
                    return (
                        <li key={`comps-${c.id}`} className="flex flex-center list-image">
                            <span className="">
                                <label className={`pr10 label label-${localColour(value, i)}`}>
                                    <span
                                        className="fix-size"
                                        style={{
                                            display: 'inline-block',
                                            textAlign: 'center',
                                        }}
                                    >
                                        {value >= 0 && <>+</>}
                                        {value == null && showPercent
                                            ? SystemText('General/Infinity')
                                            : StringHelpers.formatMetric(format, value, user.currencySymbol)}
                                    </span>
                                </label>
                            </span>
                            <span className="ml5 flex-grow">
                                <span>{c.name} </span>
                                {/* <i className="fa fa-search ml10" /> */}
                            </span>
                        </li>
                    );
                })}
            </ul>
            <div className="btn-row mt10 pt5">
                <button
                    data-testid="button-show-percent"
                    className={`btn btn-xs ${showPercent ? 'btn-primary' : 'btn-default'}`}
                    onClick={() => setShowPercent(true)}
                >
                    {SystemText('Home/Widgets/Recommends/ShowPercentage')}
                </button>
                <button
                    data-testid="button-show-value"
                    className={`btn btn-xs ${!showPercent ? 'btn-primary' : 'btn-default'}`}
                    onClick={() => setShowPercent(false)}
                >
                    {SystemText('Home/Widgets/Recommends/ShowValue')}
                </button>
            </div>
            {validCompetencies?.length > 1 && (
                <div className="mt10">
                    <button
                        className="btn btn-link"
                        onClick={() => setIdx(idx + 1 === validCompetencies.length ? 0 : idx + 1)}
                    >
                        {SystemText('Home/Widgets/Recommends/Next')}
                        <i className="fa fa-chevron-right ml5 text-xs" />
                    </button>
                </div>
            )}
        </div>
    );
};

export default withRouter(MetricRecommendations);
